export default "__VITE_ASSET__b8a1ae6b__"